import script from "./WorkspaceIntervenantsTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkspaceIntervenantsTab.vue?vue&type=script&setup=true&lang=ts"

import "./WorkspaceIntervenantsTab.vue?vue&type=style&index=0&id=1e19627d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e19627d"]])

export default __exports__